import { combineReducers } from 'redux';

import { globalInitialState, globalState, loginActions, primaryComponentsInitialState, primaryComponentsState } from 'primary-components';

import { aiToolsInitialState, aiToolsState } from './modules/aiTools';
import { datalakeInitialState, datalakeState } from './modules/datalake';
import { datascienceInitialState, datascienceState } from './modules/datascience';
import { dataStorageInitialState, dataStorageState } from './modules/dataStorage';
import { insightInitialState, insightState } from './modules/insight';
import { myAccountInitialState, myAccountState } from './modules/myAccount';
import { statusesInitialState, statusesState } from './modules/statuses';
import { toolsInitialState, toolsState } from './modules/tools';

export const initialState = {
  aiToolsState: aiToolsInitialState,
  dataStorageState: dataStorageInitialState,
  datalakeState: datalakeInitialState,
  datascienceState: datascienceInitialState,
  globalState: globalInitialState,
  insightState: insightInitialState,
  myAccountState: myAccountInitialState,
  primaryComponentsState: primaryComponentsInitialState,
  statusesState: statusesInitialState,
  toolsState: toolsInitialState
}

export const ngApp = (state, action) => {
  if (action.type === loginActions.LOG_OUT) {
    state = { globalState: state.globalState, primaryComponentsState: { apiConfigState: state.primaryComponentsState.apiConfigState } }
  }
  return combineReducers({
    aiToolsState,
    dataStorageState,
    datalakeState,
    datascienceState,
    globalState,
    insightState,
    myAccountState,
    primaryComponentsState,
    statusesState,
    toolsState
  })(state, action)
}